import LoginPresenter from "@adapters/salesFeatures/Login/presenters/Login";
export default (function (action, useCases) {
    return {
        login: new LoginPresenter(action.login, useCases.login),
    };
});
